var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"s-abrir-conta"},[_c('div',{staticClass:"container-new"},[_c('RegistrationScreenBanner'),_vm._v(" "),_c('RegistrationScreenForm',{on:{"newAccount":_vm.createNewAccountInRepository}})],1)]),_vm._v(" "),_c('FooterNewLogin')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abc4e2b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NovoCadastroUsuario.vue
// module id = ENCI
// module chunks = 0